import axios from "../utils/scripts/axios";

const jwt = localStorage.getItem("x-auth-token");

// Upload a File or Files
export function uploadFiles(file, header, onUploadProgress) {
  let formData = new FormData();

  formData.append("file", file);

  return axios.post("/api/files/", formData, {
    headers: {
      "x-folder-path": header,
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${jwt}`,
    },
    onUploadProgress,
  });
}

// Get list of all Files of a Folder
export function getFiles(path) {
  return axios.get("/api/files/", {
    params: {
      path: path,
    },
  });
}

// Get list of all Folders of a Directory
export function getFolders(path) {
  return axios.get("/api/files/directory/", {
    params: {
      path: path,
    },
  });
}

// Download a File by name
export function getFile(path, file_name) {
  return axios.get(`/api/files/${file_name}`, {
    params: {
      path: path,
    },
  });
}

// Update a File by name
export function updateFile(path, file_name, file) {
  const body = { ...file };

  return axios.put(`/api/files/${file_name}`, body, {
    headers: {
      "x-folder-path": path,
      Authorization: `Bearer ${jwt}`,
    },
  });
}

// Delete a File by name
export function deleteFile(path, file_name) {
  return axios.delete(`/api/files/${file_name}`, {
    headers: {
      "x-folder-path": path,
      Authorization: `Bearer ${jwt}`,
    },
  });
}

// Create a new Folder
export function createFolder(path) {
  return axios.post(
    "/api/files/directory/",
    {},
    {
      headers: {
        "x-folder-path": path,
        Authorization: `Bearer ${jwt}`,
      },
    }
  );
}

// Update an existing Folder
export function updateFolder(path, folder_name) {
  return axios.put(
    `/api/files/directory/${folder_name}`,
    {},
    {
      headers: {
        "x-folder-path": path,
        Authorization: `Bearer ${jwt}`,
      },
    }
  );
}

// Delete a Directory by ID
export function deleteFolder(path, folder_name) {
  return axios.delete(`/api/files/directory/${folder_name}`, {
    headers: {
      "x-folder-path": path,
      Authorization: `Bearer ${jwt}`,
    },
  });
}
